//Fetch HR List
export const getExitFormData =`
query { 
  allExitInterviews { 

    id 
    user{
      empid
      username
      firstName
      lastName
       department
      designation
    }
    exitReason 

    othersExitReason 

    newJobReason 

    othersNewJobReason 

  

    performanceReviews 

    performanceReviewsComments 

    opportunityForAdvancement 

    opportunityForAdvancementComments 

    trainingReceived 

    trainingReceivedComments 

    companyPolicies 

    companyPoliciesComments 

    responsibilities 

    responsibilitiesComments 

    workingHours 

    workingHoursComments 

    supportByManagement 

    supportByManagementComments 

    workload 

    workloadComments 

    salary 

    salaryComments 

    benefits 

    benefitsComments 

    additionalBenefits 

    additionalBenefitsComments 

    managerFeedback 

    managerFeedbackComments 

  

    jobResponsibilities 

    jobOpinion 

    frustrations 

    willingToStay 

    suggestedChanges 

    recommendCompany 

    overallComments 
    createdAt
  } 

} `;

//My List
export const getExitFormDataMyList =`
query allExitInterviewsUser($userid:ID!) { 

  allExitInterviewsUser(userId:$userid) { 

    id 
    user{
      empid
      username
      firstName
      lastName
       department
      designation
    }
    exitReason 

    othersExitReason 

    newJobReason 

    othersNewJobReason 

  

    performanceReviews 

    performanceReviewsComments 

    opportunityForAdvancement 

    opportunityForAdvancementComments 

    trainingReceived 

    trainingReceivedComments 

    companyPolicies 

    companyPoliciesComments 

    responsibilities 

    responsibilitiesComments 

    workingHours 

    workingHoursComments 

    supportByManagement 

    supportByManagementComments 

    workload 

    workloadComments 

    salary 

    salaryComments 

    benefits 

    benefitsComments 

    additionalBenefits 

    additionalBenefitsComments 

    managerFeedback 

    managerFeedbackComments 
    jobResponsibilities 

    jobOpinion 

    frustrations 

    willingToStay 

    suggestedChanges 

    recommendCompany 

    overallComments 
    createdAt
  } 

} `;

//Team List
export const getExitFormDataTeamList=`
query exitInterviewTeam($id:ID!) {  
  exitInterviewTeam(id:$id) {  
    success 
    message 
    error 
    data{ 
    id  
    user{
      empid
      username
      firstName
      lastName
       department
      designation
    }
    exitReason  
    othersExitReason  
    newJobReason  
    othersNewJobReason  
    performanceReviews  
    performanceReviewsComments  
    opportunityForAdvancement  
    opportunityForAdvancementComments  
    trainingReceived  
    trainingReceivedComments  
    companyPolicies  
    companyPoliciesComments  
    responsibilities  
    responsibilitiesComments  
    workingHours  
    workingHoursComments  
    supportByManagement  
    supportByManagementComments  
    workload  
    workloadComments  
    salary  
    salaryComments  
    benefits  
    benefitsComments  
    additionalBenefits  
    additionalBenefitsComments  
    managerFeedback  
    managerFeedbackComments  
    jobResponsibilities  
   jobOpinion  
    frustrations  
    willingToStay  
  suggestedChanges  
    recommendCompany  
    overallComments  
    createdAt
    } 
  }  
} `;

//Mutation Exit Form
export const createExitForm =
`
mutation createexitform($input:CreateExitInterviewInput!){ 

  createExitInterview(input:$input){ 

    success 

    message 

    error 

  } 

} `;

//Update Exit Form
export const updateExitForm =
`
   mutation updateExitInterview($input: UpdateExitInterviewInput!) { 
    updateExitInterview(input: $input) { 
      success 
      message 
      error 
    } 
  } 
`;

//Delete Exit Form
export const deleteExitInterviewQuery =
`
mutation deleteExitInterview($id: ID!) { 
  deleteExitInterview(id: $id) { 
    success 
    message 
    error 
  } 
}`

//Fetch Data By ID Exit Form
export const fetchExitInterviewById = `
query getExitInterviewById($id:ID!) { 
  getExitInterviewById(id: $id) { 
    id 
    exitReason 
    othersExitReason 
    newJobReason 
    othersNewJobReason 
    performanceReviews 
    performanceReviewsComments 
    opportunityForAdvancement 
  opportunityForAdvancementComments 
    trainingReceived 
    trainingReceivedComments 
    companyPolicies 
    companyPoliciesComments 
    responsibilities 
    responsibilitiesComments 
    workingHours 
    workingHoursComments 
    supportByManagement 
    supportByManagementComments 
    workload 
    workloadComments 
    salary 
    salaryComments 
    benefits 
    benefitsComments 
    additionalBenefits 
    additionalBenefitsComments 
    managerFeedback 
    managerFeedbackComments 
    jobResponsibilities 

    jobOpinion 

    frustrations 

    willingToStay 

    suggestedChanges 

    recommendCompany 

    overallComments 

  } 

}`